import styled from 'styled-components'

export const GapBetweenIcons = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto;
  column-gap: .4rem;
`;
